import styles from './copyLink.module.css';
import ClipIcon from '../../../img/icons/clip.svg';
import ColorButton from '../colorButton/colorButton';

export default function CopyLink ({ displayLink, classname = null }) {
  return (
    <div
      className={`${styles.displayContainer} ${
        classname !== null && classname
      }`}
    >
      <ClipIcon className={styles.copyLinkIcon} />
      <div className={styles.textContainer}>
        <p className={styles.displayLinkText}>{displayLink}</p>
      </div>
      <ColorButton
        label='Copy link'
        className={styles.buttonStyleOverride}
        onClick={() => navigator.clipboard.writeText(displayLink)}
      />
    </div>
  );
}
